import { falAward } from 'shared/@generated/icons/falAward';
import { falDna } from 'shared/@generated/icons/falDna';
import { falMars } from 'shared/@generated/icons/falMars';
import { falShieldCheck } from 'shared/@generated/icons/falShieldCheck';
import { falSitemap } from 'shared/@generated/icons/falSitemap';
import { falUserCircle } from 'shared/@generated/icons/falUserCircle';
import { falVenus } from 'shared/@generated/icons/falVenus';

export const listingFeatureIcons = {
  breed: falDna,
  male: falMars,
  female: falVenus,
  pedigree: falSitemap,
  breeder: falAward,
  privateSeller: falUserCircle,
  insurance: falShieldCheck,
};
